import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDeutschebahnComponent } from './simple-icons-deutschebahn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDeutschebahnComponent ],
    exports:      [ SimpleIconsDeutschebahnComponent ],
    bootstrap:    []
})
export class SimpleIconsDeutschebahnModule {}
